<ng-container *ngFor="let entry of channelEntries">
  <div class="flex flex-row items-center w-full justify-between">
    <p>
      {{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.SUPPLY_CHANNEL' | translate }}
      {{ ' ' + entry.channelNumber }}
    </p>
    <mat-slide-toggle
      #ftdcToggle
      gtm="onToggle"
      gtmAction="Intelligent Heat Control supply channel toggle"
      gtmCategory="singleRoomControl"
      [disabled]="!(entry.feature | executable: featureCommands.setActive)"
      [checked]="entry.feature | value2: featurePropertyKey.active"
      (change)="onToggleChange(ftdcToggle, entry.feature)"
    ></mat-slide-toggle>
  </div>
</ng-container>
